import { __ } from '@wordpress/i18n'

export default {
  labels: {
    name: __('Name', 'dhsv_theme'),
    submit: __('Abschicken', 'dhsv_theme'),
    company: __('Firma', 'dhsv_theme'),
    email: __('E-Mail', 'dhsv_theme'),
    phone: __('Telefon', 'dhsv_theme'),
    rmn: __('Bieten Sie bereits Online-Services an?', 'dhsv_theme'),
    anmerkungen: __('Ihre Nachricht an uns', 'dhsv_theme'),
    gdpr: __(
      'Ich habe die <a target="_blank" href="/datenschutz">Datenschutzerklärung</a> gelesen und stimme der Verarbeitung meiner Daten zu.',
      'dhsv_theme'
    ),
    solutionAreaFilter: {
      selectSolutionArea: __(
        'Bitte wählen Sie einen Lösungsbereich aus:',
        'dhsv_theme'
      ),
      selectVendor: __('Bitte wählen Sie einen Hersteller aus:', 'dhsv_theme'),
      selectSolution: __('Bitte wählen Sie eine Lösung aus:', 'dhsv_theme'),
    },
  },
  validationMessages: {
    email: __('Bitte geben Sie eine gültige E-Mail-Adresse an', 'dhsv_theme'),
    selectvendor: __(
      'Bitte wählen Sie mindestens einen Hersteller aus.',
      'dhsv_theme'
    ),
    selectproduct: __(
      'Bitte wählen Sie mindestens ein Produkt aus.',
      'dhsv_theme'
    ),
    required: __('Bitte füllen Sie das Feld aus', 'dhsv_theme'),
    gdpr: __('Bitte stimmen Sie der Übermittlung Ihrer Daten zu', 'dhsv_theme'),
  },
}
